import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES, scrollToId } from "../../lib/site";

export const Presentation = () => (
    <section id="presentation" data-testid="presentation-section" className="bg-paper py-24 text-ink lg:py-36">
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
            <div>
                <Reveal>
                    <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-signal">
                        01 — Qui sommes-nous
                    </p>
                    <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
                        Un partenaire pour vos besoins de chantier
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="mt-7 text-base leading-relaxed text-zinc-600 sm:text-lg">
                        NEBOORZY accompagne les professionnels dans leurs besoins en matériel,
                        équipements et prestations liés au bâtiment et aux travaux.
                    </p>
                    <p className="mt-4 text-base leading-relaxed text-zinc-600 sm:text-lg">
                        Parce que chaque chantier est différent, nous privilégions une approche
                        simple : comprendre votre besoin, identifier la solution appropriée et
                        vous accompagner directement sur le terrain.
                    </p>
                    <button
                        type="button"
                        data-testid="presentation-cta"
                        onClick={() => scrollToId("besoin")}
                        className="group mt-9 inline-flex items-center gap-2 rounded-full bg-ink px-7 py-4 text-base font-bold text-white transition-colors hover:bg-signal hover:text-ink"
                    >
                        Parler à un commercial
                        <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </button>
                </Reveal>
            </div>
            <Reveal delay={0.15} className="relative">
                <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl border-2 border-signal" aria-hidden="true" />
                <div className="relative overflow-hidden rounded-2xl">
                    <img
                        src={IMAGES.presentation}
                        alt="Grues de chantier au coucher du soleil"
                        loading="lazy"
                        className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
                    />
                </div>
                <p className="mt-5 font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">
                    NEBOORZY SAS — Interventions partout en France
                </p>
            </Reveal>
        </div>
    </section>
);
